import React from "react";
import styled from "styled-components";
import { defineMessages, injectIntl } from "react-intl";
import { MainContent } from "./ContactlessModalContents/MainContent";

const messages = defineMessages({
  close: {
    id: "shared.components.StyledContactlessBanner.ContactlessModal.ContactlessModalContents.close",
    defaultMessage: "Close",
  },
});

const ContactlessModalContentsBase = ({
  hideModal,
  intl: { formatMessage },
}) => {
  return (
    <LightboxContentWrapper>
      <ContactlessInformationalContainer>
        <DismissButton
          onClick={hideModal}
          type="button"
          title={formatMessage(messages.close)}
        >
          <DismissIcon className="ss-lnr-cross2" />
        </DismissButton>
        <ContactlessInformationalContent>
          <MainContent hideModal={hideModal} />
        </ContactlessInformationalContent>
      </ContactlessInformationalContainer>
    </LightboxContentWrapper>
  );
};

export const ContactlessModalContents = injectIntl(
  ContactlessModalContentsBase
);

const LightboxContentWrapper = styled.div`
  background-color: ${(props) => props.theme.color.white};
  max-width: 1022px;
  height: 100%;
  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    height: auto;
  }
`;

const ContactlessInformationalContainer = styled.div`
  position: relative;

  height: 100%;
  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    height: auto;
  }
`;

const DismissButton = styled.button`
  position: absolute;
  z-index: 1;
  top: ${(props) => props.theme.spacing.md};
  right: ${(props) => props.theme.spacing.md};
  border: none;
  background: none;
`;

const DismissIcon = styled.i`
  font-size: ${(props) => props.theme.typography.typeScale[200]};
  ${(props) => props.theme.breakpoints.tabletUp} {
    font-size: ${(props) => props.theme.typography.typeScale[400]};
  }
`;

const ContactlessInformationalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
